'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _colors = require('../settings/colors');

var _colors2 = _interopRequireDefault(_colors);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var propTypes = {
  color: _propTypes2.default.string
};

var defaultProps = {
  color: _colors2.default.icons
};

var displayName = 'IconAcademicCap';

var IconAcademicCap = function IconAcademicCap(_ref) {
  var color = _ref.color,
      custom = _objectWithoutProperties(_ref, ['color']);

  return _react2.default.createElement(
    'svg',
    _extends({ height: '24', viewBox: '0 0 24 24', width: '24' }, custom),
    _react2.default.createElement('path', { d: 'm5.85576923 10.1884615 6.02376927 2.6238462 6.0237692-2.6238462-6.0237692-2.62384612zm6.02376927 4.0707693c-.0934616 0-.1876154-.0138462-.2755385-.0553846l-7.75730769-3.3784616c-.25338462-.1107692-.41676923-.36-.41676923-.6369231 0-.27692304.16338461-.52615381.41676923-.63692304l7.75730769-3.37846154c.1758462-.07615384.3773077-.07615384.5531538 0l7.7559231 3.37846154c.2526923.11076923.4146923.36.4146923.63692304 0 .2769231-.162.5261539-.4146923.6369231l-7.7559231 3.3784616c-.087923.0415384-.1827692.0553846-.2776153.0553846z', fill: color }),
    ' ',
    _react2.default.createElement('path', { d: 'm11.8795385 17.4646154c-2.09838465 0-4.19676927-.63-6.06807696-1.89-.19246154-.1246154-.30738462-.3392308-.30738462-.5746154v-3.69c0-.3807692.30946154-.6923077.6923077-.6923077.38284615 0 .69230769.3115385.69230769.6923077v3.3161538c3.10846154 1.9315385 6.87323079 1.9315385 9.98169229 0v-3.3161538c0-.3807692.3094616-.6923077.6923077-.6923077.3828462 0 .6923077.3115385.6923077.6923077v3.69c0 .2353846-.1149231.45-.3053077.5746154-1.8713077 1.26-3.9717692 1.89-6.0701538 1.89', fill: color }),
    ' ',
    _react2.default.createElement('path', { d: 'm20.0141538 15.5815385c-.1903846 0-.3461538-.1592308-.3461538-.3461539v-5.0815384c0-.18692312.1557692-.34615389.3461538-.34615389.1924616 0 .3461539.15923077.3461539.34615389v5.0815384c0 .1869231-.1536923.3461539-.3461539.3461539', fill: color }),
    ' '
  );
};

IconAcademicCap.propTypes = propTypes;
IconAcademicCap.defaultProps = defaultProps;
IconAcademicCap.displayName = displayName;

exports.default = IconAcademicCap;
module.exports = exports.default;